import { render, staticRenderFns } from "./ScopeForm.vue?vue&type=template&id=47a5b3d2&scoped=true&"
import script from "./ScopeForm.vue?vue&type=script&lang=js&"
export * from "./ScopeForm.vue?vue&type=script&lang=js&"
import style0 from "./ScopeForm.vue?vue&type=style&index=0&id=47a5b3d2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47a5b3d2",
  null
  
)

export default component.exports